import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Popover } from "antd";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import TickIcon from "../../../Common/Svgs/TickIcon";
import { updateHub } from "../../../Redux/Slices/hubs.slice";

const NestedNameDropdown = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { selectedHub, hubEnergyBreakdown } = useSelector(
    (state) => state.hubs,
  );

  const [open, setOpen] = useState(false);

  const handleClick = (item) => {
    setOpen(false);

    dispatch(
      updateHub({
        key: "selectedHub",
        value: item,
      }),
    );

    navigate(`/hub-detail/${item.id}`);
  };

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      open={open}
      arrow={false}
      onOpenChange={(state) => setOpen(state)}
      content={
        <div>
          <div
            className="bg-background-white py-1 rounded-md"
            style={{ width: "272px" }}
          >
            <div className="max-h-[200px] overflow-y-scroll">
              {hubEnergyBreakdown?.result?.map((item) => {
                const selected = item?.id === selectedHub?.id;

                return (
                  <button
                    key={item.id}
                    type="button"
                    className="py-2 px-3 flex items-center justify-between w-full hover:bg-background rounded-md group"
                    onClick={() => handleClick(item)}
                  >
                    <p
                      className={`font-aileron font-semibold text-xs capitalize group-hover:text-black ${
                        selected ? "text-black" : "text-dark-gray"
                      }`}
                    >
                      {item?.name}
                    </p>

                    {selected && <TickIcon size={16} className="text-green" />}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      }
    >
      <button type="button" className="flex items-center gap-x-3">
        <p className="font-poppins font-medium text-2xl text-black capitalize">
          {selectedHub?.name}
        </p>

        <ChevronIcon
          className={`w-5 h-5 transform transition-all duration-[400] stroke-black ${
            open ? "-rotate-90" : "rotate-90"
          }`}
        />
      </button>
    </Popover>
  );
};

export default NestedNameDropdown;
